import AuditRoutes from "./Audit/Components";
import JournalRoutes from "./Journal/Routes";
import MessingRoutes from "./Messing/Routes";
import PaymentRoutes from "./Payment/Routes";
import PurchaseRoutes from "./Purchase/Routes";
import ReceivedRoutes from "./Received/Routes";
import RecipeRoutes from "./Recipe/Routes";
import SalesRoutes from "./Sales/Routes";
import DailyCash from "./DailyCash/Routes";
import Sync from "./Sync/Routes";

export default [...AuditRoutes, ...JournalRoutes, ...MessingRoutes, ...PaymentRoutes, ...PurchaseRoutes, ...ReceivedRoutes, ...RecipeRoutes, ...SalesRoutes, ...DailyCash, ...Sync];
